import {events} from '../events';

export const userReducer = {
    [events.USER_SET]: (state, {payload}) => ({
        ...state,
        ...payload
    }),
    [events.USER_SESSION_TOKEN_EXCHANGE_GET]: (state) => ({
        ...state,
        isAuthPending: true
    }),
    [events.USER_SESSION_TOKEN_EXCHANGE_SUCCESS]: (state, {payload: {data}}) => {
        // Capture a single timestamp so iat and exp are always a coherent pair.
        const now = Date.now();
        return {
            ...state,
            isAuthPending: false,
            ...(!state.isLogoutPending
                ? {
                    isJwtThreshold: false,
                    isJwtValid: false,
                    iat: now,
                    exp: now + data.expiresIn * 1000,
                    jwt: data.jwt,
                    refresh_token_expires_in: data.refreshTokenExpiresIn,
                    sentinel: {
                        accessToken: data.accessToken,
                        refreshToken: data.refreshToken,
                        tokenExpiresIn: data.expiresIn
                    },
                    user_firstname: data.user_firstname,
                    user_fullname: data.name,
                    user_lastname: data.user_lastname
                }
                : {})
        };
    },
    [events.USER_SESSION_TOKEN_EXCHANGE_ERROR]: (state) => ({
        ...state,
        isAuthPending: false,
        isJwtValid: false
    }),
    [events.USER_LOGOUT_POST]: (state) => ({
        ...state,
        ...{
            isLogoutPending: true
        }
    }),
    [[events.USER_LOGOUT_SUCCESS, events.USER_LOGOUT_ERROR]]: (state) => ({
        ...state,
        ...{
            isLogoutPending: false
        }
    }),
    [events.USER_SUCCESS]: (state, {payload: {data}}) => ({
        ...state,
        ...(!state.isLogoutPending ? {...data, isJwtValid: true} : {})
    }),
    [events.USER_REFRESH_TOKEN_POST]: (state) => ({
        ...state,
        isAuthPending: true
    }),
    [events.USER_REFRESH_TOKEN_ERROR]: (state) => ({
        ...state,
        isAuthPending: false
    }),
    [events.USER_REFRESH_TOKEN_SUCCESS]: (state, {payload: {data}}) => {
        // Capture a single timestamp so iat and exp are always a coherent pair.
        const now = Date.now();
        return {
            ...state,
            isAuthPending: false,
            ...(!state.isLogoutPending && state.isJwtValid
                ? {
                    isJwtThreshold: false,
                    isJwtValid: true,
                    iat: now,
                    exp: now + data.expiresIn * 1000,
                    refresh_token_expires_in: data.refreshTokenExpiresIn,
                    sentinel: {
                        accessToken: data.accessToken,
                        refreshToken: data.refreshToken,
                        tokenExpiresIn: data.expiresIn
                    },
                    user_firstname: data.user_firstname,
                    user_fullname: data.name,
                    user_lastname: data.user_lastname
                }
                : {})
        };
    }
};
